import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';

export interface IBankAssociationFormMeta {
  bankId: FormInputMeta,
  socialReason: FormInputMeta,
  association: FormInputMeta,
  setting: FormInputMeta,
  adhesionType: FormInputMeta,
  bankPrincip: FormInputMeta,
  hpxAccount: FormInputMeta,
  accountNumber: FormInputMeta,
  bnrfc: FormInputMeta,
  accountSolde: FormInputMeta,

  idAcquiereur: FormInputMeta,
  idAffaireAquiereur: FormInputMeta,
  ica: FormInputMeta,
  idProcessor: FormInputMeta,


  // Schema
  schema: any,
}

const BankAssociationFormMeta: IBankAssociationFormMeta = {} as IBankAssociationFormMeta

BankAssociationFormMeta.bankId = {
  name: 'bankId',
  type: 'text',
  label: 'ID Banque',
  placeholder: 'ID Banque',
  validation: yup.string().required(),
};

BankAssociationFormMeta.socialReason = {
  name: 'socialReason',
  type: 'text',
  label: 'Raison Social',
  placeholder: 'Raison Social',
  validation: yup.string().required(),
};

BankAssociationFormMeta.association = {
  name: 'association',
  type: 'text',
  label: 'Association',
  placeholder: 'Association',
  validation: yup.string().required(),
};

BankAssociationFormMeta.setting = {
  name: 'setting',
  type: 'text',
  label: 'Réglements',
  placeholder: 'Réglements',
  validation: yup.string().required(),
};

BankAssociationFormMeta.adhesionType = {
  name: 'adhesionType',
  type: 'select',
  label: 'Type Adhésion',
  // placeholder: 'Type Adhésion',
  options: [
    {
      label: 'Pricipale',
      value: 'principal',
    },
  ],
  validation: yup.string().required(),
};

BankAssociationFormMeta.bankPrincip = {
  name: 'adhesionType',
  type: 'select',
  label: 'Banque Princip',
  options: [
    {
      label: 'UBA',
      value: 'uba',
    },
  ],
  validation: yup.string().required(),
};

BankAssociationFormMeta.hpxAccount = {
  name: 'hpxAccount',
  type: 'text',
  label: 'Compte HPX',
  placeholder: 'Compte HPX',
  validation: yup.string().required(),
};

BankAssociationFormMeta.accountNumber = {
  name: 'accountNumber',
  type: 'text',
  label: 'Numéro de compte',
  placeholder: 'Numéro de compte',
  validation: yup.string().required(),
};

BankAssociationFormMeta.bnrfc = {
  name: 'bn-rfc',
  type: 'text',
  label: 'BN RFC',
  placeholder: 'BN RFC',
  validation: yup.string().required(),
};

BankAssociationFormMeta.accountSolde = {
  name: 'accountSolde',
  type: 'text',
  label: 'Solde Compte',
  placeholder: 'Solde Compte',
  validation: yup.string().required(),
};

BankAssociationFormMeta.idAcquiereur = {
  name: 'idAcquiereur',
  type: 'text',
  label: 'Id Acquéreur',
  placeholder: 'Id Acquéreur',
  validation: yup.string().required(),
};

BankAssociationFormMeta.idAffaireAquiereur = {
  name: 'idAffaireAcquiereur',
  type: 'text',
  label: 'ID Affaire Acquéreur',
  placeholder: 'ID Affaire Acquéreur',
  validation: yup.string().required(),
};

BankAssociationFormMeta.hpxAccount = {
  name: 'hpxAccount',
  type: 'text',
  label: 'Compte HPX',
  placeholder: 'Compte HPX',
  validation: yup.string().required(),
};

BankAssociationFormMeta.ica = {
  name: 'ica',
  type: 'text',
  label: 'ICA',
  placeholder: 'ICA',
  validation: yup.string().required(),
};

BankAssociationFormMeta.idProcessor = {
  name: 'idProcessor',
  type: 'text',
  label: 'ID Processeur',
  placeholder: 'ID Processeur',
  validation: yup.string().required(),
};


const validationSchama = getValidationSchema(BankAssociationFormMeta);

BankAssociationFormMeta.schema = yup.object().shape(validationSchama);

export default BankAssociationFormMeta;